const VerticalLayout = () => import('@/layouts/VerticalLayout')

// Same screens as the super admin dashboard; the backend scopes admins, roles
// and permissions to the facility.
const AdminsList = () => import('@/modules/superAdmin/admin/views/list.vue')
const RolesList = () => import('@/modules/superAdmin/admin/views/role.vue')

export default [
  {
    path: '/admins',
    name: 'admins',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'admins',
      component: AdminsList,
      meta: { name: 'admins', userType: 'provider', serviceTypes: 'all', permission: 'admin_list' }
    },
    {
      path: 'roles',
      name: 'businessRoles',
      component: RolesList,
      meta: { name: 'admins', userType: 'provider', serviceTypes: 'all' }
    }]
  }
]
